<template>
  <div class="client-manager-dashboard-overview">
    <div class="client-manager-overview-section">
      <div class="client-manager-overview-section-header">
        <h2 class="client-manager-overview-section-title">
          <i class="bi bi-graph-up"></i> Overview
        </h2>
      </div>
      <!-- Statistics Charts -->
      <ManagerStatsCharts :stats="stats" />
    </div>
  </div>
</template>

<script>
import '../styles/ClientManagerDashboardOverview.css';
import ManagerStatsCharts from './ManagerStatsCharts.vue';

export default {
  name: 'ClientManagerDashboardOverview',
  components: {
    ManagerStatsCharts
  },
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        totalClients: 0,
        activeClients: 0,
        totalCompanies: 0
      })
    }
  }
}
</script>
